import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from '../assets/css/team.module.css';

const images = [
    '/Nasa1.webp',
    '/Nasa2.webp',
    '/Nasa3.webp',
    '/Nasa4.webp',
    '/Atlixco1.webp',
    '/Atlixco2.webp',
    '/Atlixco3.webp',
    '/Atlixco4.webp',
    '/Atlixco5.webp',
    '/Atlixco6.webp',
    '/Famex2.webp',
    '/Famex3.webp',
    '/Famex4.webp',
    '/Mata2.webp',
    '/Mata3.webp',
    '/Mata4.webp',
    '/Mata5.webp',
    '/Miahua1.webp',
    '/Miahua2.webp',
];

const Team = () => {
    const { t } = useTranslation();
    return (
        <div className={Style.team}>
            <h1 className={Style.titleTeam}>{t('title_team')}</h1>
            <p className={Style.descriptionTeam}>{t('description_team')}</p>
            <div className={Style.imageContainer}>
                <div className={Style.imageSlide}>
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Image ${index + 1}`}
                            className={Style.collageImage}
                            loading='lazy'
                        />
                    ))}
                </div>
                <div className={Style.imageSlide}>
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Image ${index + 1}`}
                            className={Style.collageImage}
                            loading='lazy'
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default memo(Team);
